import { UserListItem } from '@/types/user';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

const VISIBLE_BRAND_COUNT = 2;

type UserAssociatedBrandsProps = {
  user: UserListItem;
};

const BrandChip = ({ name }: { name: string }) => (
  <span className="inline-flex rounded-md border border-[#E5E5E5] px-2 py-0.5 text-xs font-medium text-[#171717]">
    {name}
  </span>
);

export const UserAssociatedBrands = ({ user }: UserAssociatedBrandsProps) => {
  if (user.all_partners) {
    return <BrandChip name="Todas" />;
  }

  const partners = Array.isArray(user.partners) ? user.partners : [];
  if (partners.length === 0) {
    return <span className="text-sm text-gray-400">—</span>;
  }

  const visible = partners.slice(0, VISIBLE_BRAND_COUNT);
  const overflow = partners.slice(VISIBLE_BRAND_COUNT);

  return (
    <div className="flex flex-wrap items-center gap-1">
      {visible.map((partner) => (
        <BrandChip key={partner.id} name={partner.name} />
      ))}
      {overflow.length > 0 && (
        <Popover>
          <PopoverTrigger asChild>
            <button
              type="button"
              className="inline-flex h-5 min-w-5 items-center justify-center rounded-full border border-[#E5E5E5] px-1.5 text-xs font-medium text-[#171717] hover:bg-gray-50"
            >
              +{overflow.length}
            </button>
          </PopoverTrigger>
          <PopoverContent align="start" className="z-[80] w-48 p-2">
            <ul className="flex flex-col gap-1">
              {overflow.map((partner) => (
                <li key={partner.id}>
                  <BrandChip name={partner.name} />
                </li>
              ))}
            </ul>
          </PopoverContent>
        </Popover>
      )}
    </div>
  );
};
